import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { applicationForLeaveApi } from "../../../../../services/human-organization/application-for-leave.service";

export const useAFLRequest = () => {
  const { applicationForLeaveId } = useParams<{
    applicationForLeaveId: string;
  }>();

  return useQuery({
    queryKey: ["AFL-requests", applicationForLeaveId],
    queryFn: () => applicationForLeaveApi.getRequest(applicationForLeaveId),
    select: applicationForLeaveApi.toResponse,
  });
};
